import { useEffect } from "react";
import { useRegion } from "context/RegionContext";

/**
 * 네이티브 주소(관심지역) 설정 완료 콜백 수신.
 * 네이티브가 window.onAddressSelected(name, code) 호출 → RegionContext 에 추가 + 대표 지정.
 * RegionProvider 하위에 렌더되어야 useRegion 이 동작한다.
 */
export default function NativeAddressBridge() {
  const region = useRegion();
  useEffect(() => {
    window.onAddressSelected = (name, code) => {
      if (!code) return;
      try {
        region?.addRegion?.({ kind: "sigungu", code: String(code), name: name || String(code) });
        region?.setRepresentative?.(String(code));
      } catch {}
    };
    return () => { delete window.onAddressSelected; };
  }, [region]);
  return null;
}
